module.exports = __webpack_public_path__ + "img/IMG_9002.14f7c81a.jpg";